var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11555 0.442229C6.98004 0.171202 6.70303 0 6.40001 0C6.09699 0 5.81998 0.171202 5.68447 0.442229L0.0844669 11.6422C-0.0574132 11.926 -0.0182081 12.2668 0.184401 12.5109C0.387011 12.755 0.714739 12.8564 1.01979 12.7692L5.01978 11.6264C5.36322 11.5282 5.6 11.2143 5.6 10.8571V7.2C5.6 6.75817 5.95817 6.4 6.4 6.4C6.84183 6.4 7.2 6.75817 7.2 7.2V10.8571C7.2 11.2143 7.43678 11.5282 7.78022 11.6264L11.7802 12.7692C12.0853 12.8564 12.413 12.755 12.6156 12.5109C12.8182 12.2668 12.8574 11.926 12.7155 11.6422L7.11555 0.442229Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSendIcon);
export default __webpack_public_path__ + "static/media/WhiteSendIcon.1b5e2a80ef92adfc516abc71c989dd5d.svg";
export { ForwardRef as ReactComponent };